import { useContext } from "react";
import AuthContext from "src/contexts/AuthContext/AuthContext";

const useAuth = () => {
	const { user, userRoles } = useContext(AuthContext);

	return { user, userRoles };
};

export default useAuth;
